import "./styles/legal.css";

function Terms() {
  return (
    <main className="legal-page">

      <div className="legal-container">

        <span className="legal-label">
          Legal
        </span>

        <h1>Terms & Conditions</h1>

        <p className="legal-subtitle">
          These Terms & Conditions outline the expectations, responsibilities,
          and working principles that apply when using joelgeorge.dev or
          engaging my software engineering and development services.
        </p>

        <p className="last-updated">
          Last Updated: August 5, 2026
        </p>

        {/* Introduction */}

        <section>

          <h2>A Note From Me</h2>

          <p>
            I believe the best projects are built on trust, transparency, and
            clear communication. These Terms aren't written to make working
            together complicated—they exist to establish clear expectations so
            both parties can focus on building exceptional software.
          </p>

        </section>

        {/* Website Usage */}

        <section>

          <h2>Website Usage</h2>

          <p>
            This website exists to showcase my portfolio, professional
            experience, technical capabilities, and provide a way for potential
            clients, employers, recruiters, and collaborators to get in touch.
          </p>

          <p>
            By using this website, you agree not to misuse its content,
            interfere with its operation, or attempt unauthorized access to its
            systems.
          </p>

        </section>

        {/* Services */}

        <section>

          <h2>Services</h2>

          <p>
            Services may include, but are not limited to:
          </p>

          <ul>
            <li>Custom Web Development</li>
            <li>Frontend & Backend Engineering</li>
            <li>API Development & Integration</li>
            <li>Full-Stack Software Development</li>
            <li>Technical Consulting</li>
            <li>Maintenance & Support</li>
            <li>UI/UX Implementation</li>
          </ul>

          <p>
            Availability of services may vary depending on project scope,
            scheduling, and existing commitments.
          </p>

        </section>

        {/* Quotes */}

        <section>

          <h2>Quotes & Project Estimates</h2>

          <p>
            Any quotation, proposal, timeline, or project estimate provided
            through email or this website is supplied in good faith based on
            the information available at the time.
          </p>

          <p>
            If project requirements change significantly, revised estimates,
            timelines, or pricing may be necessary before development
            continues.
          </p>

        </section>

        {/* Payments */}

        <section>

          <h2>Payments</h2>

          <p>
            Payment schedules are agreed upon individually for each project.
          </p>

          <ul>
            <li>Projects may require an upfront deposit.</li>
            <li>Milestone-based payments may be used for larger engagements.</li>
            <li>Final deliverables may be released after final payment has been received.</li>
          </ul>

        </section>

        {/* Revisions */}

        <section>

          <h2>Revisions & Scope Changes</h2>

          <p>
            Reasonable revisions are typically included as agreed during the
            project planning stage.
          </p>

          <p>
            Requests that substantially alter the original project scope may be
            treated as additional work and quoted separately.
          </p>

        </section>

        {/* Intellectual Property */}

        <section>

          <h2>Intellectual Property</h2>

          <p>
            Unless otherwise agreed in writing, ownership of completed project
            deliverables transfers to the client after all agreed payments have
            been received.
          </p>

          <p>
            Reusable internal tools, development utilities, frameworks,
            libraries, templates, and open-source components remain subject to
            their respective licenses and ownership.
          </p>

        </section>

        {/* Confidentiality */}

        <section>

          <h2>Confidentiality</h2>

          <p>
            Client information, project discussions, business ideas, source
            code, credentials, and technical documentation are treated as
            confidential unless written permission is provided or disclosure is
            legally required.
          </p>

        </section>

        {/* Portfolio */}

        <section>

          <h2>Portfolio Showcase</h2>

          <p>
            Unless restricted by a Non-Disclosure Agreement (NDA) or written
            confidentiality agreement, completed projects may be displayed on
            joelgeorge.dev or related professional platforms as part of my
            portfolio.
          </p>

          <p>
            Sensitive business information, proprietary code, or confidential
            client data will never be intentionally disclosed.
          </p>

        </section>

        {/* AI */}

        <section>

          <h2>Use of AI-Assisted Tools</h2>

          <p>
            Modern AI-assisted tools may occasionally be used during software
            development for research, documentation, code suggestions,
            debugging, testing, or workflow automation.
          </p>

          <p>
            Every deliverable is personally reviewed and validated before being
            delivered to clients.
          </p>

        </section>

        {/* Availability */}

        <section>

          <h2>Availability</h2>

          <p>
            While reasonable efforts are made to keep this website available,
            uninterrupted operation cannot be guaranteed.
          </p>

          <p>
            Features, services, technologies, or portfolio content may change
            without prior notice.
          </p>

        </section>

        {/* Liability */}

        <section>

          <h2>Limitation of Liability</h2>

          <p>
            Every reasonable effort is made to deliver reliable, secure, and
            high-quality software solutions.
          </p>

          <p>
            However, joelgeorge.dev and Joel George shall not be liable for any
            indirect, incidental, or consequential damages resulting from the
            use of this website, third-party services, or delivered software
            beyond the extent permitted by applicable law.
          </p>

        </section>

        {/* Third Party */}

        <section>

          <h2>Third-Party Services</h2>

          <p>
            Projects may integrate services provided by third parties including
            cloud hosting providers, payment gateways, APIs, databases,
            analytics platforms, email providers, or other software vendors.
          </p>

          <p>
            Those services remain governed by their own respective terms and
            privacy policies.
          </p>

        </section>

        {/* Governing Law */}

        <section>

          <h2>Governing Law</h2>

          <p>
            These Terms & Conditions shall be governed by and interpreted in
            accordance with the applicable laws of the Republic of India.
          </p>

        </section>

        {/* Updates */}

        <section>

          <h2>Changes to These Terms</h2>

          <p>
            These Terms & Conditions may be updated periodically to reflect
            changes in services, legal requirements, or business practices.
          </p>

          <p>
            Continued use of this website after updates constitutes acceptance
            of the revised Terms.
          </p>

        </section>

        {/* Contact */}

        <section>

          <h2>Questions?</h2>

          <p>
            If you have any questions regarding these Terms & Conditions or
            wish to discuss a project, feel free to reach out.
          </p>

          <p>

            <strong>Email</strong>

            <br />

            contact@joelgeorge.dev

          </p>

          <p>
            Thank you for visiting my portfolio. I appreciate your interest and
            look forward to the opportunity to work together.
          </p>

        </section>

      </div>

    </main>
  );
}

export default Terms;